import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-history',
  templateUrl: './password-history.component.html',
  styleUrls: ['./password-history.component.scss'],
})
export class PasswordHistoryComponent implements OnInit {
  title = 'app-password-history';

  ngOnInit(): void {}
}
